import React from 'react'
import PropTypes from 'prop-types'
import { getUpdaterCreatorsForAttribute, Updaters } from '@leverege/api-attributes'
import { Selector } from '@leverege/ui-elements'

let ID_INDEX = 0;

export default class UpdaterSelector extends React.Component {

  static propTypes = {
    updater : PropTypes.object,
    attribute : PropTypes.object.isRequired,
    onSelect : PropTypes.func,
    fontIcon : PropTypes.string,
    hint : PropTypes.string
  }

  static defaultProps = {
    hint : 'Update with',
    fontIcon : 'fa fa-cogs'
  }
  
  constructor( props ) {
    super( props );
    this.state = { previous : {}, idIndex : ( ID_INDEX++ ) }
    this.onSelect = this.onSelect.bind( this );
  }

  onSelect( { value : type } ) {
    const updaterType = Updaters.getCreator( type );

    if ( this.props.onSelect ) {
      this.props.onSelect( updaterType == null ? null : updaterType.create() );
    }
  }

  render() {
    const { attribute : attr, updater, fontIcon } = this.props;
    const updateCreators = getUpdaterCreatorsForAttribute( attr );
    if ( updateCreators == null || updateCreators.length == 0 ) {
      return null;
    }
    const updaterType = Updaters.getCreator( updater && updater.type )
    const current = updaterType ? updaterType.typeName() : '__none'

    const data = [ { type : '__none', name : 'none' } ]
    for ( let n = 0; n < updateCreators.length; n++ ) {
      data.push( { name : updateCreators[n].name(), 
                   type : updateCreators[n].typeName(), 
                   updater : updateCreators[n] } )
    }
    return (
      <Selector
        nameKey="name"
        valueKey="type"
        values={data}
        value={current}
        onChange={this.onSelect} />
    )
  }

}
UpdaterSelector.hasCreators = function( attr ) {
  const updateCreators = getUpdaterCreatorsForAttribute( attr );
  if ( updateCreators == null || updateCreators.length == 0 ) {
    return false;
  }
  return true
}
